module.exports = __webpack_public_path__ + "static/media/04.541539c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/img/04.jpg
// module id = 953
// module chunks = 23